import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("infak_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Session expired - force re-login (except on login route)
      if (!window.location.pathname.includes("/infaq/login")) {
        localStorage.removeItem("infak_token");
        localStorage.removeItem("infak_user");
      }
    }
    return Promise.reject(err);
  }
);

export const publicFileUrl = (fileId) =>
  fileId ? `${API}/public/files/${fileId}` : null;
